/** Revoke the local endpoint before leaving a session, including already displayed notices. */
export async function clearLocalPush() {
  if (!('serviceWorker' in navigator)) return
  const registration = await navigator.serviceWorker.getRegistration('/')
  if (!registration) return
  const subscription = await registration.pushManager?.getSubscription()
  if (subscription) await subscription.unsubscribe()
  for (const notice of await registration.getNotifications()) notice.close()
}
